import { isInternalUser } from '../../../utils/glassboxUtils';
import { shallowEqual, useSelector } from 'react-redux';
import type { RootState } from '../../../bootstrap';
import { getUser } from '../../../redux/actions/appActions';
import { FF } from '../../../utils/utils';
import { useGetUserCompanyQuery } from '../../../state/companyService';
import { User } from '../../../interfaces/user';
import { useAuth0 } from '@auth0/auth0-react';

export function useCanViewPTSubscriptions() {
  const { isAuthenticated, isLoading } = useAuth0();
  const features = useSelector<RootState, string[]>((state) => state.app.features);
  const user = useSelector(getUser, shallowEqual) ?? ({} as User);
  const isPtSubscriptionFeatureFlagEnabled = features.includes(FF.PRO_TRANSPORT_SUBSCRIPTIONS);
  const { data: company } = useGetUserCompanyQuery(user.email, {
    skip: user.userStatus?.isTrial || !user.userStatus?.isOnCompany || !isAuthenticated || isLoading,
  });

  return isPtSubscriptionFeatureFlagEnabled && (isInternalUser(user) || user.email === company?.company_email);
}
